
import { axiosInstance, PATH } from "./client";

export interface Table {
    id: number;
    name: string;
    isActive: boolean;
    companyBranchId: number;
}

export const getTables = async (companyBranchId: number): Promise<Table[]> => {
    const response = await axiosInstance.get(
        `${PATH}/v1/common_api/company-branch/${companyBranchId}/tables`
    );
    return response.data;
};

export const createTable = async (data: { name: string; companyBranchId: number }): Promise<Table> => {
    const response = await axiosInstance.post(
        `${PATH}/v1/common_api/company-branch/${data.companyBranchId}/tables`,
        data
    );
    return response.data;
};

export const updateTable = async (id: number, data: { name?: string; isActive?: boolean }): Promise<Table> => {
    const response = await axiosInstance.patch(
        `${PATH}/v1/common_api/tables/${id}`,
        data
    );
    return response.data;
};

export const deleteTable = async (id: number): Promise<void> => {
    await axiosInstance.delete(
        `${PATH}/v1/common_api/tables/${id}`
    );
};
